<template>
    <div id="ContainerPatientActivities">
        <div class="row">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle" 
                    v-bind:titlePrefix=" $t('ActList.Activities')" 
                    v-bind:IsClinical="IsClinical"
                    v-bind:titleRef="'titleElementPatientActivitiesList'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>

                <b-row>
                    <div class="col-sm-12 col-md-3">                      
                        <MdButton
                            v-bind:Label= "$t('ActList.AddActivity')" 
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddActivity"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Name="'btn_add_activity'">
                        </MdButton>
                    </div>

                    <div class="col-sm-12 col-md-9 mb-4">
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="SearchCriteria"
                                    @keyup.enter="SearchActivities" />

                                <div class="input-group-append">
                                    <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                                        v-bind:IconClass="'mdi mdi-magnify'" v-on:click="SearchActivities">
                                    </MdButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-row>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Shared.datefrom')"                      
                            v-bind:TypeProp="'date'" 
                            v-bind:Min="'1900-01-01'"
                            v-bind:OnPressEnter="SearchActivities"
                            v-bind:Max="'2200-12-31'"
                            v-bind:isValid="isDateFromValid" 
                            v-bind:Name="'DateFrom'"
                            ref="DateFrom"                        
                            v-model="DateFrom"/>          
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdEdit 
                            v-bind:Label="$t('Shared.dateTo')"                      
                            v-bind:TypeProp="'date'" 
                            v-bind:OnPressEnter="SearchActivities"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"   
                            v-bind:isValid="isDateToValid"  
                            v-bind:Name="'DateTo'" 
                            ref="DateTo"                     
                            v-model="DateTo"/>  
                    </b-col>

                    <b-col md="3">
                        <div class="mt-3">
                            <button 
                                v-on:click="SearchActivities"
                                type="button"
                                class="btn btn-primary btn-login mx-2"												
                                id="btnsearchinput">
                                {{ $t('Shared.Search') }}
                            </button>
                        </div>
                    </b-col>
                </b-row>

                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <div v-if="showEmptyRecords" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                    <div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div>
                </div>

                <div class="row">
                    <div class="col-12 mt-2">
                        <div v-for="(it,index) in this.PatientActivities" :key="`it.patientCode-${index}`">
                            <div class="row activities">
                                <div class="col-2 mt-1">                                  
                                    <!--<b-icon  :id="'EditIcon-'+it.recId" icon="pencil-fill" v-b-tooltip.hover.top="$t('Shared.Edit')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.6" variant="light"></b-icon> -->
                                    <span @click="editActivity(it)" :id="'EditIcon-'+it.recId" v-b-tooltip.hover.top="$t('Shared.Edit')" :class="!actionsRestrictions ? 'rounded-circle tableActionBTN tableBTNtext ikon med-pen iconDisabled btndisabled':'rounded-circle tableActionBTN tableBTNtext ikon med-pen'"></span>
                                                                        
                                    <!--<b-icon @click="printActivity(it)" :id="'PrintIcon-'+it.recId" icon="printer-fill" v-b-tooltip.hover.top="$t('Shared.Print')" class="rounded-circle tableActionBTN mr-2" scale=".5" font-scale="1.6" variant="light"></b-icon> -->
                                    <span @click="printActivity(it)" :id="'PrintIcon-'+it.recId" icon="printer-fill" v-b-tooltip.hover.top="$t('Shared.Print')" class="rounded-circle tableActionBTN tableBTNtext ikon med-print"></span>

                                    <!--<b-icon @click="deleteActivity(it)" :id="'DelIcon-'+it.recId" v-if="!isReadOnly" icon="trash-fill" v-b-tooltip.hover.top="$t('Shared.Delete')" class="rounded-circle tableActionBTN-danger mr-2" scale=".5" font-scale="1.6" variant="light"></b-icon>-->
                                    <span @click="deleteActivity(it)" :id="'DelIcon-'+it.recId" v-if="!isReadOnly" v-b-tooltip.hover.top="$t('Shared.Delete')" :class="!actionsRestrictions ? 'rounded-circle tableActionBTN tableBTNtext tableActionBTN-danger ikon med-bin iconDisabled btndisabled' : 'rounded-circle tableActionBTN tableBTNtext tableActionBTN-danger ikon med-bin'"></span>

                                </div>
                                <div class="col-4">
                                    <small>{{ $t('ActList.DateAndTime') }}</small><br>{{it.datechanged}}
                                </div>
                                <div class="col-3">
                                    <small>{{ $tc('ActList.User') }}</small><br>{{it.userName}}
                                </div>
                                <div class="col-3">
                                    <small>{{ $t('ActList.ShowToPatient') }}</small><br>{{it.showToPatient ? $t('Shared.TitleYes') : $t('Shared.TitleNo')}}
                                </div>
                            </div>
                            
                            <div class="row activitiesContent">
                                <p v-html="it.memoinfo" class="col-12"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>
                <div class="row mt-4">
                    <div class="my-1 col-sm-7 col-md-6">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            @change="onChange"
                            pills
                            size="lg"
                        ></b-pagination>
                    </div>
                    <div align="right" class="mr-2 col">
                        {{ $t('Shared.Show') }}
                        <b-form-select 
                            v-model="perPage" 
                            :options="options" 
                            size="sm" 
                            id="perPageSelect"
                            v-bind:style="perPageStyle"
                            @change="perPageChange">
                        </b-form-select>
                        {{ $t('Shared.Of') }} {{totalRows}}
                    </div>
                </div>

            </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
        <MdButton
            v-bind:isReadOnly="PatientActivities.length == 0"
            v-bind:Label="$t('Shared.Report')"
            v-bind:Name="'btndailyreport'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="printActivity()"/>
        </div>

        <PatientActivitiesRep v-if="isReportVisible" 
            :closeWindow="closeParamRepWindow"
            :patientCode="this.$route.params.id"
            :patientDob="this.PatientTitle.dob"
            :recNo="recNoToReport"
            :patientName="this.PatientTitle.fullName"
            :userName="userName"
        />
    </div>    
</template>

<script>
import EnumService from '@/services/enum.service'
import Utils from '@/common/utils'
import DBFunctions from '@/common/DBFunctions.js'
import ActivitiesService from '@/services/activities.service'
import Permission from '@/common/Permission'

export default {
    /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iPI = await vm.CanViewAllowed();
            if(iPI) next()
            else next('/accessdenied');
        }) 
    },*/

    name: 'PatientActivitiesList',
    mixins: [DBFunctions, Permission],

    data() {
        return {
            //Menu : this.$store.state.leftMenu,
            InfoPatient:{},
            PatientTitle:{      
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:''
            }, 
            OptionsRightMenu:{
				visible:true,
				ItemsList:[],
				btnvisible:true,
				itemdisabled: false,
				PatientCode:''
			},
            IsClinical:false,
            SearchCriteria:'',
            DateFrom:null,
            DateTo:null,
            isReadOnly:false,
            isDateFromValid:true,
            isDateToValid:true,
            status: {
                selected:true,
                value:'Y',
                text:this.$t('Shared.Active')
            }, 
            //permission:[],
            PatientActivities: [],
            
            Header:{},
            currentPage: 1,
            perPage: 5,
            totalRows: 0, 
            options: [
                { value: 5, text: '5' },
                { value: 10, text: '10' },
                { value: 15, text: '15' },
            ],
            perPageStyle: {
                width: 'auto'
            },
            showEmptyRecords: true,
            emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },
            isReportVisible: false,
            recNoToReport: null,
            userName:'',
            EmployeeCode: this.$store.state.employeeCode,
            actionsRestrictions:false   
        }
    },

    methods: {
        /*CanViewAllowed(){
            return this.permission[0].roleCanView;
        },*/

        getListing() {
            const param = {
                PatientCode: this.$route.params.id,
                IsAlert: false,
                PageNumber: this.currentPage,
                PageSize: this.perPage,
                DateTo: Utils.formatterToISO(this.DateTo),
                DateFrom: Utils.formatterToISO(this.DateFrom),
                SearchCriteria: this.SearchCriteria
            }

            ActivitiesService
                .getAll(param)
                .then(response => {
                    if (response.status == "200" && response.data) {
                        this.PatientActivities = response.data.map(data => ({
                            userid: data.userid,
                            datechanged: Utils.formatterDateTimeToString(data.datechanged),
                            memoinfo: data.memoinfo,
                            recId: data.recId,
                            showToPatient: data.showToPatient,
                            userName: data.userName
                        }));

                        let headerString = response.headers["x-pagination"];
                        this.Header = JSON.parse(headerString);
                        this.totalRows = this.Header.TotalCount;
                        this.showEmptyRecords = response.data && response.data.length == 0 ? true : false
                        this.$emit('showEmptyRecords', this.showEmptyRecords);

                        this.actionsRestrictions = response.data[0]?.userid?.toUpperCase() === this.EmployeeCode.toUpperCase() || false;
                    }
                    this.$emit('load', false);
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                    this.$emit('load', false);
                });
        },

        SearchActivities() {
            if (this.validateDate()) {
                this.$emit('load', true);
                this.getListing();
            } else {
                this.showMessage(this.$tc('Msg.Error'), 
                    this.$t('Msg.InvalidDate') + ' ' + this.$t('Shared.Format') + ' '+ Utils.getShortDateFormat(), "errorAutoHide");          
            }
        },

        AddActivity() {
            if (this.$route.name.includes('Clinical')) {	
                this.$router.push({ name: "clinical-add-activity", params: { id: this.$route.params.id, recordid:this.$route.params.recordid } });
            } else if (this.$route.name.includes('schedulerdb-')) {
                this.$router.push({ name: "schedulerdb-activitiesAdd", params: { id: this.$route.params.id, actId: this.$route.params.actId} });
            } else {  
                this.$router.push({ name: "patient-add-activity", params: { id: this.$route.params.id } });
            }
        },

        editActivity(item) {
            if (item && item.userid) {
                if (item.userid.toUpperCase() == this.EmployeeCode.toUpperCase()) {   
                    if (this.$route.name.includes('Clinical')) {	
                        this.$router.push({ name: "clinical-edit-activity", params: { id: this.$route.params.id, recordid:this.$route.params.recordid, code: item.recId } });
                    } else if (this.$route.name.includes('schedulerdb-')) {
                        this.$router.push({ name: "schedulerdb-activitiesEdit", params: { id: this.$route.params.id, actId: this.$route.params.actId, code: item.recId } });
                    } else {  
                        this.$router.push({ name: "patient-edit-activity", params: { id: this.$route.params.id, code: item.recId } });
                    }
                } else {
                    this.showMessage(this.$tc('Msg.Warning'), this.$t('LogNoteList.NotAbleToEdit'), "warning");
                }
            }
        },

        deleteActivity(item) {
            if (item && item.userid) {
                if (item.userid.toUpperCase() == this.EmployeeCode.toUpperCase()) {
                    const activityId = item.recId
                    this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                            title: this.$t('Shared.TitleDelete'),
                            okTitle: this.$t('Shared.TitleDelete'),
                            cancelTitle: this.$t('Shared.BtnCancel'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning',
                            id:'modal_delete_activity'
                        })
                        .then(value => {
                            if(value) {
                                this.$emit('load', true);
                                ActivitiesService
                                    .delete(activityId)
                                    .then(() => {
                                        this.getListing();
                                    })
                                    .catch((error) => {
                                        this.showResponseErrorMessage(error);
                                        this.$emit('load', false);
                                    });
                            }
                        })
                } else {
                    this.showMessage(this.$tc('Msg.Warning'), this.$t('LogNoteList.NotAbleToDelete'), "warning");
                }
            }
            
        },

    
        closeParamRepWindow() {
            this.isReportVisible = false
            this.recNoToReport = null
        },
        
        printActivity(item) {
            if(this.PatientActivities.length > 0){
                if (item && item.recId) {
                    this.recNoToReport = item.recId
                    this.userName = item.userName
                }
                this.isReportVisible = true
            } else {
                setTimeout(() => 
                this.$bvToast.toast(this.$t('MdTable.nRecShow'), {
                    title:  this.$t('Msg.Info'),
                    autoHideDelay: 3000,
                    variant: "info"
                }),
                50);
            }
        },

        perPageChange(value) {
            this.$emit('load', true);
            this.perPage = value;
            this.getListing();
        },
    
        onChange(page) {
            this.$emit('load', true);
            this.currentPage = page;
            this.getListing();
        },

        validateDate(){
            this.isDateFromValid = this.DateFrom == null || this.$refs["DateFrom"].editIsValid();
            this.isDateToValid = this.DateTo == null || this.$refs["DateTo"].editIsValid();
            return this.isDateFromValid && this.isDateToValid;
        },

        async GetPatientByCode() {
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';
                
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
            }
        },

        PopulatePatientTitle(){
            const { dob, dateFrom, dateTo, age, 
                programName, patientName, ageFormatted } = this.RegistrationInfo; // Destructure for easier access
        
            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	
            
            if(this.$route.name.includes('Clinical-')){ 
                if (programName) this.PatientTitle.programName = programName; 
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age === 0 ? "0" : age;
                if (ageFormatted) this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            } else if (this.$route.name.includes('patient-')) {         
                this.PatientTitle.programName = '';
                this.PatientTitle.dateFrom = '';
                this.PatientTitle.dateTo = '';
            }
        },
        

        async PopulateTitle() {
            if(!this.$route.name.includes('Clinical-')){  
                await this.GetPatientByCode();
            } else {      
                this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
                const { dateTo, age } = this.RegistrationInfo; // Destructure for easier access

                this.IsClinical = dateTo ? false : true;
                if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
            }
            
            this.PopulatePatientTitle();
        },

        async getCurrentAppointment() {
            const currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(currentAppointmentDB.transdate)} ${currentAppointmentDB.timein}`  
        }
    },

    created() {
        this.InitializePermissions('ListView');
        //this.getPermissionLeftMenu(this.Menu, this.$route.path, this.permission);
    },

    async mounted() {
        if (!this.IsAccessAllowed()) {
            return;
        }
        
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('Clinical-') ? EnumService.ClinicalItems : 
            this.$route.name.includes('schedulerdb-') ? EnumService.AppointmentItems : EnumService.PatientItems;
		this.OptionsRightMenu.Mode = '';
		this.OptionsRightMenu.visible = true;    
		this.OptionsRightMenu.btnvisible = true;
        this.OptionsRightMenu.active_el = this.$route.name.includes('Clinical-') ? 'ClinicalActivities' : 'PatientActivities';
		this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.isReadOnly = this.$store.state.isPatientActivitiesEHRReadOnly;

        this.$emit('load', true);
        await this.PopulateTitle();
        if (this.$route.name.includes('schedulerdb'))
            await this.getCurrentAppointment();
            
        this.getListing();
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },
}
</script>